import { Link } from '@arco-design/web-react'
import cs from 'classnames'
import styles from './index.module.less'
export default function NewLink(props) {
    if (props.dangerouslySetInnerHTML) {
        console.log(props);

    }
    return <Link hoverable={false} {...props} className={cs(styles.redqueenLink,props.className)}/>
}